import React, { useEffect, useState } from 'react';
import { useLocation  } from 'react-router-dom';
import useApi from '../../CustomHooks/useApi';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { insurancesViewAPI } from '../../../api/apiClient';
import '../../../css/Views/VariantInsurancesView.css';
import getParticipantStatusStyle, { ParticipantStatus } from '../../../utils/getParticipantStatusStyle';
import { faPenToSquare, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import ActionIcon from '../../Trips/Participants/ActionIcon';
import Loading from '../../../Loading';
import ExportInsuranceButton from './ExportInsuranceButton';


const VariantInsurancesView = ({variantGuid}) => {
  const { callApi, isLoading } = useApi();
  const [participants, setParticipants] = useState([]);
  const [filterOption, setFilterOption] = useState("all");
  const [editMode, setEditMode] = useState(false);
const [editedParticipants, setEditedParticipants] = useState({});
const [initialParticipants, setInitialParticipants] = useState([]);
const [isSaving, setIsSaving] = useState(false);
  const location = useLocation();
const tripName = location.state?.tripName || '';
const variantName = location.state?.variantName || '';

  useEffect(() => {
    if (!variantGuid) return;
    callApi(() => insurancesViewAPI.getParticipantsForVariant(variantGuid), (data) => {
        setParticipants(data);
        setInitialParticipants(JSON.parse(JSON.stringify(data)));


    });
  }, [variantGuid]);


  const filtered = participants
  .filter(p => {
    switch (filterOption) {
      case "nnwChronic":
        return p.nnwCovered != null && p.isChronicIllness;
      case "nnwNoChronic":
        return p.nnwCovered != null && !p.isChronicIllness;
      case "krChronic":
        return p.krCovered != null && p.isChronicIllness;
      case "krNoChronic":
        return p.krCovered != null && !p.isChronicIllness;
      default:
        return true;
    }
  })
  .sort((a, b) => a.preferredName.localeCompare(b.preferredName));

  const handleSaveChanges = async () => {
    setIsSaving(true);
    const updates = Object.entries(editedParticipants)
        .map(([participantGuid, { nnw, kr }]) => {
        const update = { participantGuid };
    
        if (nnw !== null && nnw !== undefined) update.nnwCovered = nnw;
        if (kr !== null && kr !== undefined) update.krCovered = kr;
    
        return update;
        })
        .filter(update => Object.keys(update).length > 1);
  
        await callApi(() => insurancesViewAPI.updateInsurances(updates),
        async () => {
          setEditedParticipants({});
          setEditMode(false);
          await callApi(() => insurancesViewAPI.getParticipantsForVariant(variantGuid), (data) => {
            setParticipants(data);
            setInitialParticipants(JSON.parse(JSON.stringify(data)));
          });
        }
      );
    setIsSaving(false);
  };

  const handleCheckboxChange = (guid, field, value) => {
    setParticipants(prev =>
      prev.map(p =>
        p.guid === guid ? { ...p, [field]: value } : p
      )
    );
  
    setEditedParticipants(prev => {
      const initialParticipant = initialParticipants.find(p => p.guid === guid);
      if (!initialParticipant) return prev;
  
      const prevEntry = prev[guid] || {
        nnw: initialParticipant.nnwCovered,
        kr: initialParticipant.krCovered
      };
  
      const updatedEntry = {
        ...prevEntry,
        [field === "nnwCovered" ? "nnw" : "kr"]: value
      };
  
      const isNnwSame = updatedEntry.nnw === initialParticipant.nnwCovered;
      const isKrSame = updatedEntry.kr === initialParticipant.krCovered;
  
      const newEditedParticipants = { ...prev };
  
      if (isNnwSame && isKrSame) {
        delete newEditedParticipants[guid];
      } else {
        newEditedParticipants[guid] = updatedEntry;
      }
  
      return newEditedParticipants;
    });
  };
  
  
  
  
  
  const getIcon = (val) => {
    if (val === true) {
      return <FontAwesomeIcon icon={faCircleCheck} className="insurance-icon-green" title="Wykupione" />;
    } else if (val === false) {
      return <FontAwesomeIcon icon={faCircleCheck} className="insurance-icon-gray" title="Brak ubezpieczenia" />;
    } else {
      return <span className="insurance-icon-dash" title="Nie dotyczy">–</span>;
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString("pl-PL", { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  return (
    <div className="insurance-page">
        <div className="insurance-variant-header">
  <div className="insurance-trip-name">{tripName}</div>
  <p className="insurance-variant-name">{variantName}</p>
</div>
<div className="edit-buttons">
        <ActionIcon
            icon={<FontAwesomeIcon icon={faPenToSquare} />}
            label={editMode ? "Cofnij" : "Edytuj"}
            onClick={() => {
                if (editMode) {
                  setParticipants(JSON.parse(JSON.stringify(initialParticipants)));
                  setEditedParticipants({});
                }
                setEditMode(prev => !prev);
              }}
            active={editMode}
            disabled={isLoading}
        />
        {editMode && (
            <ActionIcon
            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            label="Zapisz"
            onClick={handleSaveChanges}
            disabled={isLoading}
            />
        )}
        {filterOption != "all" && <ActionIcon
            icon={<i className="fa-solid fa-file-export" />}
            label="Eksport"
            onClick={() => {
                ExportInsuranceButton.export({
                participants: filtered,
                filter: filterOption,
                });
            }}
            disabled={isLoading || editMode}
            />
        }

        </div>

      <h2 className="insurance-title">Ubezpieczenia <span className="insurance-count">({filtered.length})</span></h2>

     


      <div className="insurance-filters">
  <label className="insurance-dropdown-label">
    Filtr:
    <select
      value={filterOption}
      onChange={(e) => setFilterOption(e.target.value)}
      className="insurance-dropdown"
    >
      <option value="all">Wszystkie</option>
      <option value="nnwChronic">NNW ze zwyżką</option>
      <option value="nnwNoChronic">NNW bez zwyżki</option>
      <option value="krChronic">KR ze zwyżką</option>
      <option value="krNoChronic">KR bez zwyżki</option>
    </select>
  </label>
</div>
      {isLoading || isSaving ? (
        <Loading text="Ładowanie danych"/>
      ) : filtered.length === 0 ? (
        <p className="no-data-message">Brak uczestników z ubezpieczeniem.</p>
      ) : (
        <div className="insurance-table-wrapper">
        <table className="insurance-table">
          <thead>
            <tr>
              <th >Uczestnix</th>
              <th>Dowód</th>
              <th>Data ur.</th>
              <th className="centered-col">NNW</th>
              <th className="centered-col">KR</th>
              <th className="centered-col">Zw.</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(p => {
              const statusStyle = getParticipantStatusStyle(p.status);
              return (
                <React.Fragment key={p.guid}>
                <tr
                  className={`insurance-participant-row ${statusStyle.statusClass} ${
                    editedParticipants.hasOwnProperty(p.guid) ? "edited-row" : ""
                  } ${p.status === ParticipantStatus.Cancelled ? 'cancelled-text' : ''}`}
                >
                  <td className="insurance-name-cell">
                    <i className={`fa-solid ${statusStyle.icon} insurance-user-icon ${statusStyle.statusClass}`} />
                    {p.preferredName}
                  </td>
                  <td>{p.firstName} {p.lastName}</td>
                  <td>{formatDate(p.birthDate)}</td>
                  <td
                        className="narrow-header insurance-symbol-cell centered-col"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            if (!editMode || p.nnwCovered === null || p.status === ParticipantStatus.Cancelled)  return;
                            handleCheckboxChange(p.guid, 'nnwCovered', !(editedParticipants[p.guid]?.nnw ?? p.nnwCovered));
                        }}
                        >
                        {editMode && p.nnwCovered !== null  && p.status !== ParticipantStatus.Cancelled ? (
                            <input
                            type="checkbox"
                            style={{ cursor: 'pointer' }}
                            checked={editedParticipants[p.guid]?.nnw ?? p.nnwCovered}
                            onChange={(e) => handleCheckboxChange(p.guid, 'nnwCovered', e.target.checked)}
                            onClick={(e) => e.stopPropagation()} 
                            />
                        ) : (
                            getIcon(p.nnwCovered)
                        )}
                        </td>


                        <td
                        className="narrow-header insurance-symbol-cell centered-col"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            if (!editMode || p.krCovered === null || p.status === ParticipantStatus.Cancelled) return;
                            handleCheckboxChange(p.guid, 'krCovered', !(editedParticipants[p.guid]?.kr ?? p.krCovered));
                        }}
                        >
                         {editMode && p.krCovered !== null  && p.status !== ParticipantStatus.Cancelled ? (
                            <input
                            type="checkbox"
                            style={{ cursor: 'pointer' }}
                            checked={editedParticipants[p.guid]?.kr ?? p.krCovered}
                            onChange={(e) => handleCheckboxChange(p.guid, 'krCovered', e.target.checked)}
                            onClick={(e) => e.stopPropagation()}
                            />
                        ) : (
                            getIcon(p.krCovered)
                        )}
                        </td>



                        <td className="narrow-header insurance-symbol-cell centered-col">
                          {p.isChronicIllness && (
                            <FontAwesomeIcon icon={faCircleCheck} className="insurance-icon-green" title="Zwyżka za chorobę przewlekłą" />
                          )}
                        </td>
                </tr>
              </React.Fragment>
              );
            })}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
};

export default VariantInsurancesView;
